export const competitorsStepTexts = {
    selectCountry: "activation.setup.competitors.step.select.country",
    selectPrimary: "activation.setup.competitors.step.select.primary",
    selectCompetitors: "activation.setup.competitors.step.select.competitors",
    autocompletePlaceholder: "activation.setup.competitors.step.autocomplete.placeholder",
    emptyCompetitors: "activation.setup.competitors.step.select.competitors.empty",
    aiEmptyCompetitorsNoPrimary: "activation.setup.competitors.step.ai.select.competitors.no_primary.empty",
    aiEmptyCompetitorsNoPrimarySubMessage:
        "activation.setup.competitors.step.ai.select.competitors.no_primary.empty.sub",
    primaryPlaceholder: "activation.setup.competitors.step.select.competitors.dropdown.placeholder",
    errorRemoveDuplication: "activation.setup.competitors.step.error.toast.remove.duplication",
    errorLimitReached: "activation.setup.competitors.step.error.toast.limit.reached",
    errorPasteBlockedByLimit: "activation.setup.competitors.step.error.toast.paste.blocked.by.limit",
    errorInvalidPaseData: "activation.setup.competitors.step.error.toast.paste.data.invalid",
    domains: "common.domains",
    domainsSelected: "activation.setup.competitors.step.domains.selected",
    defaultReason: "activation.setup.competitors.step.ai.default.reason",
    loaderTitle: "activation.setup.competitors.step.ai.loader.title",
    loaderSubTitle: "activation.setup.competitors.step.ai.loader.subtitle",
    aiSucessToastText: "activation.setup.competitors.step.ai.sucess.toast",
    aiSameResponseToastText: "activation.setup.competitors.step.ai.same.response",
};

export const TITLE_TEXT = "activation.setup.competitors.step.ai.title";

export const FALLBACK_CHIP_LEADERS = "activation.setup.competitors.step.ai.fallback.chip.leaders";
export const FALLBACK_CHIP_BRANDS = "activation.setup.competitors.step.ai.fallback.chip.brands";
export const FALLBACK_CHIP_COMPANIES = "activation.setup.competitors.step.ai.fallback.chip.companies";
